// src/pages/GrammarPage.jsx - COMPLETE REPLACEMENT FILE
import React from 'react';
import GrammarHub from './GrammarHub.jsx';

/**
 * GrammarPage - Main entry point for Grammar module
 * Now simplified to use modular components
 *
 * Features:
 * - Progress continuation from last position
 * - Mistake tracking and review
 * - Lesson-to-practice pillar connections
 * - Multi-level support (B1, B2, C1)
 * - Translation-ready with i18n
 *
 * This component serves as the entry point and delegates
 * all functionality to the GrammarHub component which manages:
 * - Level selection
 * - Pillar navigation
 * - Exercise engine
 * - Progress tracking
 *
 * Props:
 * @param {Function} onBack - Navigation callback to return to previous page
 * @param {String} userLevel - User's current level (default: 'B1')
 */
const GrammarPage = ({ onBack, userLevel = 'B1' }) => {
  return (
    <GrammarHub
      onBack={onBack}
      userLevel={userLevel}
    />
  );
};

export default GrammarPage;